import { FieldText, FlexBox, IconButton } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { Field, GenericField } from 'redux-form';

import styles from './phoneNumber.module.scss';

export const MATCH_FIELD = 'match';

interface OwnProps {
  field: string;
  index: number;
  isOnlyNumber: boolean;
  onRemove: (index: number) => void;
  onPhoneNumberRemove: () => void;
}

type Props = GenericField<OwnProps> & OwnProps;

export function PhoneNumber({
  field,
  index,
  isOnlyNumber,
  onPhoneNumberRemove,
  onRemove,
}: Props): JSX.Element {
  const handleRemove = useCallback(() => {
    onRemove(index);
    onPhoneNumberRemove();
  }, [index, onPhoneNumberRemove, onRemove]);

  return (
    <FlexBox alignItems="center" justifyContent="space-between">
      <Field
        component={FieldText}
        label={`Phone number #${index + 1}`}
        name={`${field}.${MATCH_FIELD}`}
        placeholder="Phone number (e.g. +12058321080 or +1)"
      />
      <IconButton
        className={styles.trashButton}
        disabled={isOnlyNumber}
        icon="trash"
        onClick={handleRemove}
        type="button"
        variant="tertiary"
      />
    </FlexBox>
  );
}
